import {
  AuxNotificationGroupConfig,
  AuxNotificationStyleEnum,
  AuxNotificationToastTypeEnum,
} from '@blk/aladdin-react-components';
import { dequal } from 'dequal';
import 'lodash';
import type { Dispatch, SetStateAction } from 'react';
import { UUID } from './UUIDGenerator';

export const dismissNotification = (
  setNotifications: Dispatch<SetStateAction<AuxNotificationGroupConfig[]>>,
  id: string
) => {
  setNotifications((prevNotifications) => prevNotifications.filter((notification) => notification.id !== id));
};

export const generateNewNotifications = (
  newNotification: AuxNotificationGroupConfig | undefined,
  prevNotifications: AuxNotificationGroupConfig[]
) => {
  if (!newNotification) {
    return prevNotifications;
  }

  const duplicateMessage = prevNotifications.find((notification: AuxNotificationGroupConfig) => {
    if (Array.isArray(notification.message) && Array.isArray(newNotification.message)) {
      return dequal(notification.message, newNotification.message);
    }
    return notification.message === newNotification.message;
  });

  return duplicateMessage ? prevNotifications : [newNotification, ...prevNotifications];
};

export const setBasicNotification = (
  setNotifications: Dispatch<SetStateAction<AuxNotificationGroupConfig[]>>,
  message: string,
  notificationStyle: AuxNotificationStyleEnum,
  isTimeout: boolean = false,
  id: string = UUID()
) => {
  const newNotification = {
    id,
    message,
    notificationStyle,
    isToast: isTimeout,
    toastType: isTimeout ? AuxNotificationToastTypeEnum.TIMEOUT : AuxNotificationToastTypeEnum.PERSISTENT,
    closeIconClickedCallback: () => {
      dismissNotification(setNotifications, id);
    },
  };
  setNotifications((prevStateNotifications) => generateNewNotifications(newNotification, prevStateNotifications));
};

/* istanbul ignore next */
export const setCustomNotification = ({
  setNotifications,
  message,
  notificationStyle,
  isTimeout = false,
  prevNotifications = [],
  id = UUID(),
  buttons,
}: {
  setNotifications: Dispatch<SetStateAction<AuxNotificationGroupConfig[]>>;
  message: AuxNotificationGroupConfig['message'];
  notificationStyle: AuxNotificationGroupConfig['notificationStyle'];
  isTimeout?: boolean;
  prevNotifications?: AuxNotificationGroupConfig[];
  id?: string;
  buttons?: AuxNotificationGroupConfig['buttons'];
}) => {
  const newNotification = {
    id,
    message,
    notificationStyle,
    isToast: isTimeout,
    toastType: isTimeout ? AuxNotificationToastTypeEnum.TIMEOUT : AuxNotificationToastTypeEnum.PERSISTENT,
    closeIconClickedCallback: () => {
      dismissNotification(setNotifications, id);
    },
    buttons,
  };
  setNotifications((prevStateNotifications) => {
    const oldNotifications = prevNotifications.length > 0 ? prevNotifications : prevStateNotifications;
    const notifications = generateNewNotifications(newNotification, oldNotifications);
    return notifications;
  });
};
